export default {
    PRIVATE_NOTE: "privateNote",
    STRUCTURED: "structured",
    SELF_STRUCTURED: "self-structured",
};
